// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftCircleOutlinedSvg from "@fishx/icons-svg/es/asn/LeftCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleOutlinedSvg
  }));
};

LeftCircleOutlined.displayName = 'LeftCircleOutlined';
export default React.forwardRef(LeftCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LeftCircleOutlined.js
// module id = 3024
// module chunks = 0